import './AddedToCart.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckmarkCircle } from 'images/icons/CheckmarkCircle.svg';

export const AddedToCart = () => {
  const { t } = useTranslation();
  return (
    <div className='added-to-cart'>
      <CheckmarkCircle className='icon' />
      {t('AddedToCart', { ns: 'subscriptionsAndPricing' })}
    </div>
  );
};
